export const isDevelopment = process.env.NODE_ENV == "development";

export function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export function formatPhoneNumber(phone: string): string {
  if (/^\+7\d{10}$/.test(phone)) {
    const first = phone.slice(2, 5);
    const second = phone.slice(5, 8);
    const third = phone.slice(8, 10);
    const fourth = phone.slice(10);
    return `+7 (${first}) ${second}-${third}-${fourth}`;
  }

  if (/^8\d{10}$/.test(phone)) {
    const first = phone.slice(1, 4);
    const second = phone.slice(4, 7);
    const third = phone.slice(7, 9);
    const fourth = phone.slice(9);
    return `8 (${first}) ${second}-${third}-${fourth}`;
  }

  return phone;
}

export function getEnumNumericValues<T extends { [key: string]: string | number }>(enumObj: T): Array<T[keyof T] & number> {
  return Object.values(enumObj).filter((value) => typeof value == "number") as Array<T[keyof T] & number>;
}

export function convertBytesToMB(bytes?: number) {
  if (bytes === null || bytes === undefined) {
    return NaN;
  }
  // Convert bytes to MB (1 MB = 1024 * 1024 bytes)
  const megabytes = bytes / (1024 * 1024);

  return megabytes;
}
